import actions from '@/store/modules/job/actions.js'
import mutations from '@/store/modules/job/mutations.js'
import getters from '@/store/modules/job/getters.js'
import {base_state} from '@/store/modules/base/state.js'

const state = {
  ...base_state,
  'api_module': 'job'
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}